import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserCreators } from "redux/modules/user";
import { useNavigate, useParams } from "react-router-dom";

import { MyPageHead } from "components/pages/myPage/common/index";


const Tos = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const params = useParams();
    console.log(params)

    return (
        <div>
            { params.type === 'tos' &&
                <div>
                    <MyPageHead title='서비스 이용 약관'/>
                </div>
            }
            { params.type === 'pp' &&
                <div>
                    <MyPageHead title='개인정보처리방침'/>
                </div>
            }
            { params.type === 'marketing' &&
                <div>
                    <MyPageHead title='마케팅 메시지 수신을 위한 이메일 동의'/>
                </div>
            }
        </div>
    )
}

export default Tos;